module.exports = __webpack_public_path__ + "static/media/gb5.85a0af77.png";